import React, {useState, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation} from "react-router-dom";
import {Tab, Tabs} from '../../components/common/TabCustom';

import { ALERT_TYPE, MASK_FORMAT, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, TRIBUTO_TYPE, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {APIS} from '../../config/apis';
import {ServerRequest} from '../../utils/apiweb';
import { useEntidad, useForm, useNav, useUnsavedChangesGuard, useFormErrors } from '../../components/hooks';

import {
    Loading,
    SectionHeading,
    InputLista,
    InputFormat,
    InputEntidad,
    DatePickerCustom,
    InputEjercicio,
    Accordion,
    CheckboxButton,
    CheckboxButtonGroup,
    FormError,
    FormLabel
} from '../../components/common';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {CloneObject} from '../../utils/helpers';
import {getDateId} from '../../utils/convert';
import DataTaggerFormRedux from '../../components/controls/DataTaggerFormRedux';
import ProcedimientoParametrosGrid from '../../components/controls/ProcedimientoParametrosGrid';
import ProcedimientoVariablesGrid from '../../components/controls/ProcedimientoVariablesGrid';
import EmisionCuotasGrid from '../../components/controls/EmisionCuotasGrid';
import EmisionCalculosGrid from '../../components/controls/EmisionCalculosGrid';
import EmisionConceptosGrid from '../../components/controls/EmisionConceptosGrid';
import EmisionCuentasCorrientesGrid from '../../components/controls/EmisionCuentasCorrientesGrid';
import EmisionImputacionesContablesGrid from '../../components/controls/EmisionImputacionesContablesGrid';
import {isNull} from '../../utils/validator';
import EmisionBoletaSeccionesGrid from '../../components/controls/EmisionBoletaSeccionesGrid';
import {TIPS} from "../../consts/tips";

function EmisionDefinicionView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const filters = location.state?.filters;

    //variables
    const entityInit = {
        emisionDefinicion: {
            id: 0,
            idTipoTributo: 0,
            idNumeracion: 0,
            idProcedimiento: 0,
            idEstadoEmisionDefinicion: 0,
            idEmisionDefinicionBase: 0,
            idBoletaDefinicion: 0,
            numero: '',
            descripcion: '',
            codigoDelegacion: '',
            periodo: '',
            procesaPlanes: false,
            procesaRubros: false,
            procesaCarteles: false,
            procesaElementos: false,
            partidaUnificada: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPagoAnticipado: false,
            fechaReliquidacionDesde: null,
            fechaReliquidacionHasta: null,
            modulo: ''
        },
        archivos: [],
        observaciones: [],
        etiquetas: [],
        funciones: [],
        procedimientos: [],
        emisionVariables: [],
        emisionCuotas: [],
        emisionCalculos: [],
        emisionBoletaSecciones: [],
        emisionConceptos: [],
        emisionCuentasCorrientes: [],
        emisionImputacionesContables: []
    };

    //hooks
    const navigate = useNav()

    const [state, setState] = useState({
        processKey: `EmisionDefinicion_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        tabActive: "procedimiento"
    });
    const [timestampUpdateVariables, setTimestampUpdateVariables] = useState(null)
    const [pendingChange, setPendingChange] = useState(false);
    const [listClaseElemento, setClaseElemento] = useState(false);
    const [definicionCerrada, setDefinicionCerrada] = useState(false);
    const [emisionEjecucionCierre, setEmisionEjecucionCierre] = useState(null);
    const [datosOpen, setDatosOpen] = useState(true);
    const [parametrosOpen, setParametrosOpen] = useState(params.mode === OPERATION_MODE.NEW);
    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);

    const mount = () => {
        if (state.id > 0) {
            if (state.mode === OPERATION_MODE.EDIT) {
                CheckEmisionEjecucion(() => FindEmisionDefinicion());
            } else {
                FindEmisionDefinicion();
            }
        } else {
            SearchProcedimientos();
        }
    }
    useEffect(mount, []);

    const [listTiposDeclaracionJurada, setListTiposDeclaracionJurada] = useState([]);

    const [emisionDefinicion_formValues, emisionDefinicion_formHandle, , emisionDefinicion_formSet] = useForm({
        idTipoTributo: 0,
        idNumeracion: 0,
        idProcedimiento: 0,
        idEstadoEmisionDefinicion: 230, //Activa
        idEmisionDefinicionBase: 0,
        idBoletaDefinicion: 0,
        numero: '',
        descripcion: '',
        codigoDelegacion: '',
        periodo: '',
        procesaPlanes: false,
        procesaRubros: false,
        procesaCarteles: false,
        procesaElementos: false,
        partidaUnificada: false,
        calculoMostradorWeb: false,
        calculoMasivo: false,
        calculoPagoAnticipado: false,
        fechaReliquidacionDesde: null,
        fechaReliquidacionHasta: null,
    }, 'emisionDefinicion_');

    let listVariables = useMemo(() =>
            getListVariables(state.entity.emisionVariables.filter(x => x.state !== 'r'),
                state.entity.procedimientos,
                emisionDefinicion_formValues.idProcedimiento),
        [emisionDefinicion_formValues.idProcedimiento, timestampUpdateVariables]);

    const [getTableEntidad, , readyClaseElemento] = useEntidad({
        entidades: ['ClaseElemento'],
        onLoaded: (entidades, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'ClaseElemento',
            timeout: 0
        }
    });

    useEffect(() => {
        if (readyClaseElemento && emisionDefinicion_formValues.idTipoTributo > 0) {
            const list = getTableEntidad("ClaseElemento").filter(f => isNull(f.idTipoTributo) || f.idTipoTributo === emisionDefinicion_formValues.idTipoTributo);
            setClaseElemento(list);
            SearchEntidadTipoDeclaracionJurada();
        }
    }, [readyClaseElemento, emisionDefinicion_formValues.idTipoTributo]);

    const modeView = useMemo(() => (state.mode === OPERATION_MODE.VIEW || definicionCerrada), [state.mode, definicionCerrada])

    //handles
    const emisionDefinicion_formHandleProxy = (event) => {
        emisionDefinicion_formHandle(event);
        setPendingChange(true);
    }
    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickGuardar = () => {
        const errors = getErrors();
        if (errors.idTipoTributo || errors.idNumeracion || errors.codigoDelegacion || errors.periodo || errors.idEstadoEmisionDefinicion || errors.descripcion) setDatosOpen(true);
        if (errors.idEmisionDefinicionBase) setParametrosOpen(true);
        if (errors.idProcedimiento) SetTabActive('procedimiento');

        if (validate() && validarCalculosCabecera()) {
            if (state.id === 0) {
                AddEmisionDefinicion();
            } else if (definicionCerrada) {
                ModifyEmisionDefinicion();
            } else {
                CheckEmisionEjecucion((ejecucion) => {
                    if (ejecucion) {
                        ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No se guardó ningún cambio porque la definición empezó a usarse en una ejecución mientras la editabas.');
                        FindEmisionDefinicion();
                    } else {
                        ModifyEmisionDefinicion();
                    }
                });
            }
        }
        ;
    };

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindEmisionDefinicion = (response) => {
        response.json()
            .then((data) => {

                if (data.emisionDefinicion.fechaReliquidacionDesde) data.emisionDefinicion.fechaReliquidacionDesde = new Date(data.emisionDefinicion.fechaReliquidacionDesde);
                if (data.emisionDefinicion.fechaReliquidacionHasta) data.emisionDefinicion.fechaReliquidacionHasta = new Date(data.emisionDefinicion.fechaReliquidacionHasta);

                data.emisionCuotas.forEach(x => {
                    if (x.fechaVencimiento1) x.fechaVencimiento1 = new Date(x.fechaVencimiento1);
                    if (x.fechaVencimiento2) x.fechaVencimiento2 = new Date(x.fechaVencimiento2);
                });

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setTimestampUpdateVariables(new Date());
                setPendingChange(false);
                emisionDefinicion_formSet({
                    idTipoTributo: data.emisionDefinicion.idTipoTributo,
                    idNumeracion: data.emisionDefinicion.idNumeracion,
                    idProcedimiento: data.emisionDefinicion.idProcedimiento,
                    idEstadoEmisionDefinicion: data.emisionDefinicion.idEstadoEmisionDefinicion,
                    idEmisionDefinicionBase: data.emisionDefinicion.idEmisionDefinicionBase,
                    idBoletaDefinicion: data.emisionDefinicion.idBoletaDefinicion,
                    numero: data.emisionDefinicion.numero,
                    descripcion: data.emisionDefinicion.descripcion,
                    codigoDelegacion: data.emisionDefinicion.codigoDelegacion,
                    periodo: data.emisionDefinicion.periodo,
                    procesaPlanes: data.emisionDefinicion.procesaPlanes,
                    procesaRubros: data.emisionDefinicion.procesaRubros,
                    procesaCarteles: data.emisionDefinicion.procesaCarteles,
                    procesaElementos: data.emisionDefinicion.procesaElementos,
                    partidaUnificada: data.emisionDefinicion.partidaUnificada,
                    calculoMostradorWeb: data.emisionDefinicion.calculoMostradorWeb,
                    calculoMasivo: data.emisionDefinicion.calculoMasivo,
                    calculoPagoAnticipado: data.emisionDefinicion.calculoPagoAnticipado,
                    fechaReliquidacionDesde: data.emisionDefinicion.fechaReliquidacionDesde,
                    fechaReliquidacionHasta: data.emisionDefinicion.fechaReliquidacionHasta,
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };
    const callbackSuccessSearchProcedimientos = (response) => {
        response.json()
            .then((data) => {

                let entityAdd = CloneObject(state.entity);
                entityAdd.procedimientos = data;
                setState(prevState => {
                    return {...prevState, loading: false, entity: entityAdd};
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: [],
                    Observacion: [],
                    Etiqueta: []
                }));
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };
    const callbackSuccessSearchTipoDeclaracionJurada = (response) => {
        response.json()
            .then((data) => {
                setListTiposDeclaracionJurada(data["TipoDeclaracionJurada"]);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    //funciones
    function getListVariables(emisionVariables, procedimientos, idProcedimiento) {
        return (idProcedimiento > 0)
            ? procedimientos.find(f => f.id === idProcedimiento)
                .procedimientoVariables.filter(f => emisionVariables.map(x => x.idProcedimientoVariable).includes(f.id))
                .sort((a, b) => a.orden - b.orden)
            : [];
    }

    function getErrors() {

        const errors = {};

        if (emisionDefinicion_formValues.idTipoTributo === 0) errors.idTipoTributo = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (emisionDefinicion_formValues.idNumeracion === 0) errors.idNumeracion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (emisionDefinicion_formValues.idEstadoEmisionDefinicion === 0) errors.idEstadoEmisionDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (emisionDefinicion_formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (emisionDefinicion_formValues.codigoDelegacion.length === 0) errors.codigoDelegacion = VALIDATION_MESSAGE.REQUIRED;
        if (emisionDefinicion_formValues.idProcedimiento === 0) errors.idProcedimiento = VALIDATION_MESSAGE.REQUIRED_OPTION;

        if (emisionDefinicion_formValues.periodo.length === 0) errors.periodo = VALIDATION_MESSAGE.REQUIRED;
        else if (emisionDefinicion_formValues.periodo.length < 4) errors.periodo = 'Ingresá 4 dígitos';

        if (emisionDefinicion_formValues.calculoPagoAnticipado && emisionDefinicion_formValues.idEmisionDefinicionBase === 0) errors.idEmisionDefinicionBase = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function validarCalculosCabecera() {

        if (state.entity.emisionCuentasCorrientes.length > 0 && !state.entity.emisionCuentasCorrientes.some(f => f.state !== 'r' && f.tasaCabecera)) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe definir un cálculo de cta. cte. como tasa cabecera');
            return false;
        }

        return true;
    }

    function SearchProcedimientos() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCEDIMIENTO,
            null,
            null,
            callbackSuccessSearchProcedimientos,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchEntidadTipoDeclaracionJurada() {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = '/TipoDeclaracionJurada/filter?idFilter=' + emisionDefinicion_formValues.idTipoTributo;
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.ENTIDAD,
            paramsUrl,
            null,
            callbackSuccessSearchTipoDeclaracionJurada,
            callbackNoSuccess,
            callbackError
        );
    }

    function CheckEmisionEjecucion(callback) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {

                    const ejecucion = data.emisionEjecucionCierre ?? null;
                    setEmisionEjecucionCierre(ejecucion);
                    setDefinicionCerrada(ejecucion !== null);
                    callback(ejecucion);

                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/cierre/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function FindEmisionDefinicion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            paramsUrl,
            null,
            callbackSuccessFindEmisionDefinicion,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddEmisionDefinicion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Definición ingresada correctamente", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        allowNavigation();
                        navigate({
                            to: `/emision-definicion/${OPERATION_MODE.EDIT}/${row.emisionDefinicion.id}`,
                            refresh: true,
                            replace: true,
                        })
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            emisionDefinicion: {
                ...state.entity.emisionDefinicion,
                idTipoTributo: emisionDefinicion_formValues.idTipoTributo,
                idNumeracion: emisionDefinicion_formValues.idNumeracion,
                idProcedimiento: emisionDefinicion_formValues.idProcedimiento,
                idEstadoEmisionDefinicion: emisionDefinicion_formValues.idEstadoEmisionDefinicion,
                idEmisionDefinicionBase: emisionDefinicion_formValues.idEmisionDefinicionBase,
                idBoletaDefinicion: emisionDefinicion_formValues.idBoletaDefinicion,
                numero: '', //es automatico
                descripcion: emisionDefinicion_formValues.descripcion,
                codigoDelegacion: emisionDefinicion_formValues.codigoDelegacion,
                periodo: emisionDefinicion_formValues.periodo,
                procesaPlanes: emisionDefinicion_formValues.procesaPlanes,
                procesaRubros: emisionDefinicion_formValues.procesaRubros,
                procesaCarteles: emisionDefinicion_formValues.procesaCarteles,
                procesaElementos: emisionDefinicion_formValues.procesaElementos,
                partidaUnificada: emisionDefinicion_formValues.partidaUnificada,
                calculoMostradorWeb: emisionDefinicion_formValues.calculoMostradorWeb,
                calculoMasivo: emisionDefinicion_formValues.calculoMasivo,
                calculoPagoAnticipado: emisionDefinicion_formValues.calculoPagoAnticipado,
                fechaReliquidacionDesde: emisionDefinicion_formValues.fechaReliquidacionDesde,
                fechaReliquidacionHasta: emisionDefinicion_formValues.fechaReliquidacionHasta,
            },
            archivos: [],
            observaciones: [],
            etiquetas: [],
            procedimientos: [],
            funciones: [],
            emisionVariables: [],
            emisionCuotas: [],
            emisionCalculos: [],
            emisionBoletaSecciones: [],
            emisionConceptos: [],
            emisionCuentasCorrientes: [],
            emisionImputacionesContables: []
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            null,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyEmisionDefinicion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Definición actualizada correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                callbackSuccessFindEmisionDefinicion(response);
            });
        };

        const dataBody = {
            emisionDefinicion: {
                ...state.entity.emisionDefinicion,
                idTipoTributo: emisionDefinicion_formValues.idTipoTributo,
                idNumeracion: emisionDefinicion_formValues.idNumeracion,
                idProcedimiento: emisionDefinicion_formValues.idProcedimiento,
                idEstadoEmisionDefinicion: emisionDefinicion_formValues.idEstadoEmisionDefinicion,
                idEmisionDefinicionBase: emisionDefinicion_formValues.idEmisionDefinicionBase,
                idBoletaDefinicion: emisionDefinicion_formValues.idBoletaDefinicion,
                numero: emisionDefinicion_formValues.numero,
                descripcion: emisionDefinicion_formValues.descripcion,
                codigoDelegacion: emisionDefinicion_formValues.codigoDelegacion,
                periodo: emisionDefinicion_formValues.periodo,
                procesaPlanes: emisionDefinicion_formValues.procesaPlanes,
                procesaRubros: emisionDefinicion_formValues.procesaRubros,
                procesaCarteles: emisionDefinicion_formValues.procesaCarteles,
                procesaElementos: emisionDefinicion_formValues.procesaElementos,
                partidaUnificada: emisionDefinicion_formValues.partidaUnificada,
                calculoMostradorWeb: emisionDefinicion_formValues.calculoMostradorWeb,
                calculoMasivo: emisionDefinicion_formValues.calculoMasivo,
                calculoPagoAnticipado: emisionDefinicion_formValues.calculoPagoAnticipado,
                fechaReliquidacionDesde: emisionDefinicion_formValues.fechaReliquidacionDesde,
                fechaReliquidacionHasta: emisionDefinicion_formValues.fechaReliquidacionHasta,
            },
            archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : [],
            procedimientos: [],
            funciones: [],
            emisionVariables: state.entity.emisionVariables.filter(f => f.state !== 'o'),
            emisionCuotas: state.entity.emisionCuotas.filter(f => f.state !== 'o'),
            emisionCalculos: state.entity.emisionCalculos.filter(f => f.state !== 'o'),
            emisionBoletaSecciones: state.entity.emisionBoletaSecciones.filter(f => f.state !== 'o'),
            emisionConceptos: state.entity.emisionConceptos, //va completo para validar
            emisionCuentasCorrientes: state.entity.emisionCuentasCorrientes, //va completo para validar
            emisionImputacionesContables: state.entity.emisionImputacionesContables.filter(f => f.state !== 'o')
        };

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs

        let entity = CloneObject(state.entity);

        if (typeEntity === 'EmisionVariable') {
            //esta entidad trabaja sobre idProcedimientoVariable como identificador, ya que un solo registro hijo hace referencia a cada registro maestro
            if (row.state === 'a') {
                const index = entity.emisionVariables.indexOf(entity.emisionVariables.find(x => x.idProcedimientoVariable === row.idProcedimientoVariable));
                if (index === -1) { //lo agrego porque no existe en la bd
                    entity.emisionVariables.push(row);
                } else { //estaba borrado temporalmente, entonces lo recupero
                    entity.emisionVariables[index].state = 'o';
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionVariables = entity.emisionVariables.filter(f => f.idProcedimientoVariable !== row.idProcedimientoVariable);
                } else {
                    let item = entity.emisionVariables.find(x => x.idProcedimientoVariable === row.idProcedimientoVariable);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'EmisionCuota') {
            if (row.state === 'a') {
                entity.emisionCuotas.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionCuotas.indexOf(entity.emisionCuotas.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionCuotas[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionCuotas = entity.emisionCuotas.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionCuotas.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'EmisionCalculo') {
            if (row.state === 'a') {
                entity.emisionCalculos.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionCalculos.indexOf(entity.emisionCalculos.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionCalculos[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionCalculos = entity.emisionCalculos.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionCalculos.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'EmisionBoletaSeccion') {
            if (row.state === 'a') {
                entity.emisionBoletaSecciones.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionBoletaSecciones.indexOf(entity.emisionBoletaSecciones.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionBoletaSecciones[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionBoletaSecciones = entity.emisionBoletaSecciones.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionBoletaSecciones.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'EmisionConcepto') {
            if (row.state === 'a') {
                entity.emisionConceptos.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionConceptos.indexOf(entity.emisionConceptos.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionConceptos[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionConceptos = entity.emisionConceptos.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionConceptos.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        if (typeEntity === 'EmisionCuentaCorriente') {
            if (row.state === 'a') {
                entity.emisionCuentasCorrientes.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionCuentasCorrientes.indexOf(entity.emisionCuentasCorrientes.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionCuentasCorrientes[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionCuentasCorrientes = entity.emisionCuentasCorrientes.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionCuentasCorrientes.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }

            // if (state.entity.emisionDefinicion.partidaUnificada) {
            if (emisionDefinicion_formValues.partidaUnificada) {
                if (row.tasaCabecera) {
                    entity.emisionCuentasCorrientes.filter(f => f.tasaCabecera && f.id !== row.id && f.state !== 'r').forEach(x => {
                        x.tasaCabecera = false;
                        if (x.id > 0) x.state = 'm';
                    });
                }
            } else {
                row.tasaCabecera = true;
            }
        }

        if (typeEntity === 'EmisionImputacionContable') {
            if (row.state === 'a') {
                entity.emisionImputacionesContables.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionImputacionesContables.indexOf(entity.emisionImputacionesContables.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionImputacionesContables[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionImputacionesContables = entity.emisionImputacionesContables.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionImputacionesContables.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        setState(prevState => {
            return {
                ...prevState,
                entity: entity
            };
        });
        setPendingChange(true);
        setTimestampUpdateVariables(new Date());
    }

    function setPartidaUnificada(partidaUnificada) {
        let entity = CloneObject(state.entity);
        entity.emisionCuentasCorrientes.filter(f => f.state !== 'r').forEach(x => {
            if (partidaUnificada) {
                x.tasaCabecera = false;
                if (x.id > 0) x.state = 'm';
            } else {
                x.tasaCabecera = true;
                if (x.id > 0) x.state = 'm';
            }
        });

        setState(prevState => {
            return {
                ...prevState,
                entity: entity
            };
        });
        setPendingChange(true);
    }


    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    return (
        <>

            <Loading visible={state.loading}></Loading>

            <SectionHeading
                titles={[
                    {title: 'Emisión'},
                    {title: 'Definición de emisiones', url: '/emision-definiciones'},
                    {title: params.mode === OPERATION_MODE.NEW ? 'Nueva' : `Número de definición: ${emisionDefinicion_formValues.numero}`}
                ]}
            />

            <div className="m-top-20">

                <section className='section-accordion'>

                    <div className="m-top-20 m-bottom-20">
                        {(state.mode === OPERATION_MODE.EDIT && emisionEjecucionCierre) && (
                            <div className='row'>
                                <div className="col-12 m-bottom-20">
                                    <span className="busqueda-mensaje m-left-20">
                                        <span className="material-symbols-outlined" aria-hidden="true">warning</span>
                                        Sólo podés editar las cuotas y la información adicional: la definición ya se usa en la ejecución {emisionEjecucionCierre.numero} - {emisionEjecucionCierre.descripcion}.
                                    </span>
                                </div>
                            </div>
                        )}
                        <Accordion title="Datos principales" open={datosOpen} onToggle={setDatosOpen}>
                            <div className='row form-basic'>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <FormLabel htmlFor="emisionDefinicion_idTipoTributo" required>Tipo de
                                        tributo</FormLabel>
                                    <InputLista
                                        name="emisionDefinicion_idTipoTributo"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoTributo') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.idTipoTributo}
                                        onChange={(event) => {
                                            const idTipoTributo = parseInt(event.target.value);
                                            emisionDefinicion_formSet({
                                                ...emisionDefinicion_formValues,
                                                idTipoTributo: idTipoTributo,
                                                idProcedimiento: 0
                                            });
                                            setPendingChange(true);
                                        }}
                                        disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView || state.entity.emisionVariables.filter(f => f.state !== 'r').length > 0}
                                        lista="TipoTributo"
                                    />
                                    <FormError message={errorOf('idTipoTributo')} />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <FormLabel htmlFor="emisionDefinicion_idNumeracion" required>Numeración
                                        de VEPs</FormLabel>
                                    <InputEntidad
                                        name="emisionDefinicion_idNumeracion"
                                        title="Numeración"
                                        tipName={TIPS.NAME.MODALS.NUMERACION_MODAL}
                                        placeholder=""
                                        className={`form-control ${errorOf('idNumeracion') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.idNumeracion}
                                        onChange={emisionDefinicion_formHandleProxy}
                                        disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                        entidad="EmisionNumeracion"
                                        onFormat={(row) => (row && row.id) ? row.nombre : ''}
                                        columns={[
                                            {Header: 'Numeración', accessor: 'nombre', width: '70%'},
                                            {Header: 'Próximo valor', accessor: 'valorProximo', width: '30%'}
                                        ]}
                                        filter={(row) => {
                                            return (row.idTipoTributo === null || row.idTipoTributo === emisionDefinicion_formValues.idTipoTributo)
                                        }}
                                        memo={false}
                                    />
                                    <FormError message={errorOf('idNumeracion')} />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <FormLabel htmlFor="emisionDefinicion_codigoDelegacion" required>Código
                                        delegación</FormLabel>
                                    <input
                                        name="emisionDefinicion_codigoDelegacion"
                                        type="text"
                                        placeholder=""
                                        maxLength={1000}
                                        className={`form-control ${errorOf('codigoDelegacion') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.codigoDelegacion}
                                        onChange={emisionDefinicion_formHandleProxy}
                                        disabled={modeView}
                                    />
                                    <FormError message={errorOf('codigoDelegacion')} />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <FormLabel htmlFor="emisionDefinicion_periodo" required>Período</FormLabel>
                                    <InputEjercicio
                                        name="emisionDefinicion_periodo"
                                        placeholder=""
                                        className={`form-control ${errorOf('periodo') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.periodo}
                                        onChange={emisionDefinicion_formHandleProxy}
                                        disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                    />
                                    <FormError message={errorOf('periodo')} />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <FormLabel htmlFor="emisionDefinicion_idEstadoEmisionDefinicion" required>Estado</FormLabel>
                                    <InputLista
                                        name="emisionDefinicion_idEstadoEmisionDefinicion"
                                        placeholder=""
                                        className={`form-control ${errorOf('idEstadoEmisionDefinicion') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.idEstadoEmisionDefinicion}
                                        onChange={emisionDefinicion_formHandleProxy}
                                        disabled={modeView}
                                        lista="EstadoEmisionDefinicion"
                                    />
                                    <FormError message={errorOf('idEstadoEmisionDefinicion')} />
                                </div>
                                <div className="col-12 col-md-4 col-lg-2">
                                    <label htmlFor="emisionDefinicion_numero" className="form-label">Número de
                                        definición</label>
                                    <InputFormat
                                        name="emisionDefinicion_numero"
                                        placeholder="[automático]"
                                        className="form-control"
                                        mask={MASK_FORMAT.EMISION_NUMERO}
                                        maskPlaceholder={null}
                                        value={emisionDefinicion_formValues.numero}
                                        disabled={true}
                                    />
                                    <FormError />
                                </div>
                                <div className="col-12 col-lg-8">
                                    <FormLabel htmlFor="emisionDefinicion_descripcion" required>Descripción</FormLabel>
                                    <input
                                        name="emisionDefinicion_descripcion"
                                        type="text"
                                        placeholder=""
                                        maxLength={1000}
                                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                        value={emisionDefinicion_formValues.descripcion}
                                        onChange={emisionDefinicion_formHandleProxy}
                                        disabled={modeView}
                                    />
                                    <FormError message={errorOf('descripcion')} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label htmlFor="emisionDefinicion_idBoletaDefinicion" className="form-label">Definición
                                        de boleta</label>
                                    <InputEntidad
                                        name="emisionDefinicion_idBoletaDefinicion"
                                        placeholder=""
                                        tipName={TIPS.NAME.MODALS.DEFINICION_BOLETA_MODAL}
                                        className="form-control"
                                        value={emisionDefinicion_formValues.idBoletaDefinicion}
                                        onChange={(event) => {
                                            const idBoletaDefinicion = parseInt(event.target.value);
                                            emisionDefinicion_formSet({
                                                ...emisionDefinicion_formValues,
                                                idBoletaDefinicion: idBoletaDefinicion
                                            });
                                            setPendingChange(true);
                                            if (state.tabActive === 'boleta_seccion') {
                                                SetTabActive('procedimiento');
                                            }
                                        }}
                                        disabled={modeView || state.entity.emisionBoletaSecciones.filter(f => f.state !== 'r').length > 0}
                                        entidad="BoletaDefinicion"
                                        filter={(row) => isNull(row.idTipoTributo) || row.idTipoTributo === emisionDefinicion_formValues.idTipoTributo}
                                    />
                                </div>
                            </div>
                        </Accordion>

                        <div className="m-top-20">
                            <Accordion title="Parámetros" open={parametrosOpen} onToggle={setParametrosOpen}>
                                <div className='row form-basic'>
                                    <div className="col-12 col-md-auto">
                                        <CheckboxButtonGroup label="Cálculo">
                                            <CheckboxButton
                                                name="emisionDefinicion_calculoPagoAnticipado"
                                                label="Cálculo pago anticipado"
                                                checked={emisionDefinicion_formValues.calculoPagoAnticipado}
                                                onChange={(event) => {
                                                    const calculoPagoAnticipado = event.target.checked;
                                                    const calculoMostradorWeb = calculoPagoAnticipado ? false : emisionDefinicion_formValues.calculoMostradorWeb;
                                                    const calculoMasivo = calculoPagoAnticipado ? true : emisionDefinicion_formValues.calculoMasivo;
                                                    emisionDefinicion_formSet({
                                                        ...emisionDefinicion_formValues,
                                                        calculoPagoAnticipado: calculoPagoAnticipado,
                                                        calculoMostradorWeb: calculoMostradorWeb,
                                                        calculoMasivo: calculoMasivo,
                                                        idEmisionDefinicionBase: 0,
                                                        idProcedimiento: 0
                                                    });
                                                    setPendingChange(true);
                                                }}
                                                disabled={emisionDefinicion_formValues.idTipoTributo === 0 || state.mode !== OPERATION_MODE.NEW}
                                            />
                                            <CheckboxButton
                                                name="emisionDefinicion_calculoMostradorWeb"
                                                label="Cálculo web"
                                                checked={emisionDefinicion_formValues.calculoMostradorWeb}
                                                onChange={emisionDefinicion_formHandleProxy}
                                                disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                            />
                                            <CheckboxButton
                                                name="emisionDefinicion_calculoMasivo"
                                                label="Cálculo masivo"
                                                checked={emisionDefinicion_formValues.calculoMasivo}
                                                onChange={emisionDefinicion_formHandleProxy}
                                                disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                            />
                                            <CheckboxButton
                                                name="emisionDefinicion_partidaUnificada"
                                                label="Partida unificada"
                                                checked={emisionDefinicion_formValues.partidaUnificada}
                                                onChange={(event) => {
                                                    const partidaUnificada = event.target.checked;
                                                    emisionDefinicion_formSet({
                                                        ...emisionDefinicion_formValues,
                                                        partidaUnificada: partidaUnificada
                                                    });
                                                    setPartidaUnificada(partidaUnificada);
                                                }}
                                                disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                            />
                                        </CheckboxButtonGroup>
                                    </div>
                                    {[TRIBUTO_TYPE.COMERCIOS, TRIBUTO_TYPE.FONDEADEROS, TRIBUTO_TYPE.CEMENTERIOS].includes(emisionDefinicion_formValues.idTipoTributo) &&
                                        <div className="col-12 col-md-auto">
                                            <CheckboxButtonGroup label="Procesos">
                                                {[TRIBUTO_TYPE.COMERCIOS].includes(emisionDefinicion_formValues.idTipoTributo) &&
                                                    <>
                                                        <CheckboxButton
                                                            name="emisionDefinicion_procesaRubros"
                                                            label="Procesa rubros"
                                                            checked={emisionDefinicion_formValues.procesaRubros}
                                                            onChange={emisionDefinicion_formHandleProxy}
                                                            disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                                        />
                                                        <CheckboxButton
                                                            name="emisionDefinicion_procesaCarteles"
                                                            label="Procesa carteles"
                                                            checked={emisionDefinicion_formValues.procesaCarteles}
                                                            onChange={emisionDefinicion_formHandleProxy}
                                                            disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                                        />
                                                    </>
                                                }
                                                <CheckboxButton
                                                    name="emisionDefinicion_procesaElementos"
                                                    label="Procesa elementos"
                                                    checked={emisionDefinicion_formValues.procesaElementos}
                                                    onChange={emisionDefinicion_formHandleProxy}
                                                    disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                                />
                                            </CheckboxButtonGroup>
                                        </div>
                                    }
                                    {!emisionDefinicion_formValues.calculoPagoAnticipado && emisionDefinicion_formValues.calculoMostradorWeb &&
                                        <div className="row col-12 col-lg-8 no-m-horizontal no-p-horizontal">
                                            <div className="col-12 col-md-6 col-lg-3">
                                                <label htmlFor="emisionDefinicion_fechaReliquidacionDesde"
                                                       className="form-label">Reliquidable desde</label>
                                                <DatePickerCustom
                                                    name="emisionDefinicion_fechaReliquidacionDesde"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={emisionDefinicion_formValues.fechaReliquidacionDesde}
                                                    onChange={emisionDefinicion_formHandleProxy}
                                                    disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                                />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-3">
                                                <label htmlFor="emisionDefinicion_fechaReliquidacionHasta"
                                                       className="form-label">Reliquidable hasta</label>
                                                <DatePickerCustom
                                                    name="emisionDefinicion_fechaReliquidacionHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={emisionDefinicion_formValues.fechaReliquidacionHasta}
                                                    onChange={emisionDefinicion_formHandleProxy}
                                                    disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {emisionDefinicion_formValues.calculoPagoAnticipado &&
                                        <div className="row col-12 col-md-8 no-m-horizontal no-p-horizontal">
                                            <div className="col-12 col-md-12 col-lg-6">
                                                <FormLabel htmlFor="emisionDefinicion_idEmisionDefinicionBase" required>Emisión base para el cálculo de pago
                                                    anticipado:</FormLabel>
                                                <InputEntidad
                                                    name="emisionDefinicion_idEmisionDefinicionBase"
                                                    title="Emisiones"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idEmisionDefinicionBase') ? 'is-invalid' : ''}`}
                                                    value={emisionDefinicion_formValues.idEmisionDefinicionBase}
                                                    onChange={(event) => {
                                                        if (event.target.value) {
                                                            const row = event.target.row;
                                                            emisionDefinicion_formSet({
                                                                ...emisionDefinicion_formValues,
                                                                idNumeracion: row.idNumeracion,
                                                                idProcedimiento: row.idProcedimiento,
                                                                idEmisionDefinicionBase: row.id,
                                                                periodo: row.periodo,
                                                                procesaRubros: row.procesaRubros,
                                                                procesaCarteles: row.procesaCarteles,
                                                                procesaElementos: row.procesaElementos,
                                                                partidaUnificada: row.partidaUnificada,
                                                                fechaReliquidacionDesde: null,
                                                                fechaReliquidacionHasta: null
                                                            });
                                                        } else {
                                                            emisionDefinicion_formSet({
                                                                ...emisionDefinicion_formValues,
                                                                idNumeracion: 0,
                                                                idProcedimiento: 0,
                                                                idEmisionDefinicionBase: 0,
                                                                periodo: '',
                                                                procesaRubros: false,
                                                                procesaCarteles: false,
                                                                procesaElementos: false,
                                                                partidaUnificada: false,
                                                                fechaReliquidacionDesde: null,
                                                                fechaReliquidacionHasta: null
                                                            });
                                                        }
                                                        setPendingChange(true);
                                                    }}
                                                    entidad="EmisionDefinicion"
                                                    onFormat={(row) => (row && row.id) ? `${row.numero} - ${row.descripcion}` : ''}
                                                    columns={[
                                                        {Header: 'Número', accessor: 'numero', width: '20%'},
                                                        {Header: 'Descripción', accessor: 'descripcion', width: '80%'},
                                                    ]}
                                                    filter={(row) => {
                                                        return (row.idTipoTributo === emisionDefinicion_formValues.idTipoTributo && !row.calculoPagoAnticipado)
                                                    }}
                                                    disabled={state.mode !== OPERATION_MODE.NEW}
                                                    memo={false}
                                                />
                                                <FormError message={errorOf('idEmisionDefinicionBase')} />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Accordion>
                        </div>

                        {(state.mode !== OPERATION_MODE.NEW) && (
                            <>
                                <div className="m-top-20">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de definición de emisión"
                                            processKey={state.processKey}
                                            entidad="EmisionDefinicion"
                                            idEntidad={state.id}
                                            disabled={(state.mode === OPERATION_MODE.VIEW)}
                                            onChange={(row) => setPendingChange(true)}
                                        />
                                    </Accordion>
                                </div>
                            </>
                        )}

                        <Tabs
                            id="tabs-emision-definicion"
                            activeKey={state.tabActive}
                            className="m-top-20"
                            onSelect={(tab) => SetTabActive(tab)}
                        >
                            <Tab eventKey="procedimiento" title="Procedimiento">
                                <div className='tab-panel'>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-lg-10 m-bottom-20">
                                            <FormLabel htmlFor="emisionDefinicion_idProcedimiento" required>Procedimiento</FormLabel>
                                            <InputEntidad
                                                name="emisionDefinicion_idProcedimiento"
                                                title="Procedimiento"
                                                tipName={TIPS.NAME.MODALS.PROCEDIMIENTO_MODAL}
                                                placeholder=""
                                                className={`form-control ${errorOf('idProcedimiento') ? 'is-invalid' : ''}`}
                                                value={emisionDefinicion_formValues.idProcedimiento}
                                                onChange={emisionDefinicion_formHandleProxy}
                                                disabled={emisionDefinicion_formValues.calculoPagoAnticipado || modeView || state.entity.emisionVariables.filter(f => f.state !== 'r').length > 0}
                                                entidad="Procedimiento"
                                                onFormat={(row) => (row && row.id) ? `${row.nombre} - ${row.descripcion}` : ''}
                                                columns={[
                                                    {Header: 'Nombre', accessor: 'nombre', width: '35%'},
                                                    {Header: 'Descripción', accessor: 'descripcion', width: '65%'}
                                                ]}
                                                filter={(row) => {
                                                    return row.idTipoTributo === emisionDefinicion_formValues.idTipoTributo
                                                }}
                                            />
                                            <FormError message={errorOf('idProcedimiento')} />
                                        </div>
                                        <div className="col-12">
                                            <ProcedimientoParametrosGrid
                                                disabled={true}
                                                data={{
                                                    idEmisionEjecucion: 0,
                                                    listParametros: (emisionDefinicion_formValues.idProcedimiento > 0)
                                                        ? state.entity.procedimientos.find(f => f.id === emisionDefinicion_formValues.idProcedimiento).procedimientoParametros
                                                        : [],
                                                    listValores: []
                                                }}
                                                onChange={(typeEntity, row) => {
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="variables" title="Variables"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <ProcedimientoVariablesGrid
                                        processKey={state.processKey}
                                        disabled={modeView}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            list: state.entity.emisionVariables,
                                            listAll: (emisionDefinicion_formValues.idProcedimiento > 0)
                                                ? state.entity.procedimientos.find(f => f.id === emisionDefinicion_formValues.idProcedimiento).procedimientoVariables
                                                : [],
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="cuotas" title="Cuotas"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionCuotasGrid
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            listCuotas: state.entity.emisionCuotas,
                                            listVariables: listVariables,
                                            listFunciones: state.entity.funciones
                                        }}
                                        periodo={emisionDefinicion_formValues.periodo}
                                        procesaRubros={emisionDefinicion_formValues.procesaRubros}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="calculos" title="Cálculos"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionCalculosGrid
                                        disabled={modeView}
                                        procesaRubros={emisionDefinicion_formValues.procesaRubros}
                                        procesaCarteles={emisionDefinicion_formValues.procesaCarteles}
                                        procesaElementos={emisionDefinicion_formValues.procesaElementos}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            listCalculos: state.entity.emisionCalculos,
                                            listVariables: listVariables,
                                            listFunciones: state.entity.funciones,
                                            listParametros: (emisionDefinicion_formValues.idProcedimiento > 0)
                                                ? state.entity.procedimientos.find(f => f.id === emisionDefinicion_formValues.idProcedimiento).procedimientoParametros
                                                : [],
                                            listElementos: listClaseElemento,
                                            listTiposDeclaracionJurada: listTiposDeclaracionJurada
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="boleta_seccion" title="Boleta/Secciones"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW && emisionDefinicion_formValues.idBoletaDefinicion) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionBoletaSeccionesGrid
                                        disabled={modeView}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            idBoletaDefinicion: emisionDefinicion_formValues.idBoletaDefinicion,
                                            listBoletaSecciones: state.entity.emisionBoletaSecciones,
                                            listCalculos: state.entity.emisionCalculos,
                                            listVariables: listVariables,
                                            listFunciones: state.entity.funciones,
                                            listParametros: (emisionDefinicion_formValues.idProcedimiento > 0)
                                                ? state.entity.procedimientos.find(f => f.id === emisionDefinicion_formValues.idProcedimiento).procedimientoParametros
                                                : []
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="conceptos" title="Items/Conceptos"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionConceptosGrid
                                        disabled={modeView}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            listConceptos: state.entity.emisionConceptos,
                                            listCalculos: state.entity.emisionCalculos,
                                            listFunciones: state.entity.funciones
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="ctacte" title="Cuenta corriente"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionCuentasCorrientesGrid
                                        partidaUnificada={emisionDefinicion_formValues.partidaUnificada}
                                        disabled={modeView}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            listCuentasCorrientes: state.entity.emisionCuentasCorrientes,
                                            listCalculos: state.entity.emisionCalculos,
                                            listFunciones: state.entity.funciones
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="contabilidad" title="Imputación contable"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionImputacionesContablesGrid
                                        disabled={modeView}
                                        data={{
                                            idEmisionDefinicion: state.entity.emisionDefinicion.id,
                                            listImputacionesContables: state.entity.emisionImputacionesContables,
                                            listCalculos: state.entity.emisionCalculos,
                                            listFunciones: state.entity.funciones
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                        </Tabs>

                    </div>

                </section>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver
                        filters={filters}
                        to="/emision-definiciones"
                        pendingChange={pendingChange}
                        processKey={state.processKey}
                        allowNavigation={allowNavigation}
                    />
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default EmisionDefinicionView;
